import { Question } from '@components/ui/question';
import { useData } from '@hooks/form';
import { useNotificationChannel } from '@hooks/notification';
import AttachMoneySharpIcon from '@mui/icons-material/AttachMoneySharp';
import { LoadingButton } from '@mui/lab';
import { InputAdornment, Stack } from '@mui/material';
import { useGetIncentive, useUpdateIncentive } from '@queries/incentives';
import { FunctionComponent } from 'react';

type IncentiveSettingsState = {
  amount?: number;
  name?: string;
};

export type IncentiveSettingsProps = {
  gid: string;
};

export const IncentiveSettings: FunctionComponent<IncentiveSettingsProps> = (
  props,
) => {
  const { gid } = props;
  const { success } = useNotificationChannel();
  const getIncentiveQuery = useGetIncentive({ body: {}, gid });
  const updateIncentiveMutation = useUpdateIncentive();
  const activeIncentive = getIncentiveQuery.data?.data;

  const donationExperienceData = useData<IncentiveSettingsState>({
    amount: activeIncentive?.offer?.settings?.value,
    name: activeIncentive?.name,
  });

  function onSuccess() {
    success(`The incentive ${gid} was updated.`);
  }

  const { data, setValueFromKey } = donationExperienceData;

  const onSave = async () => {
    updateIncentiveMutation.mutate(
      {
        gid,
        hostedCampaignGeneratorUpdate: {
          amount: data.amount,
          name: data.name,
        },
      },
      { onSuccess },
    );
  };

  const nameError = updateIncentiveMutation.data?.errors?.find(
    ({ field }) => field === 'name',
  );

  return (
    <Stack spacing={2}>
      <Question
        inputProps={{
          error: Boolean(nameError),
          helperText: nameError?.message,
          id: 'incentive-name',
          label: 'Incentive Name',
          variant: 'outlined',
        }}
        onChange={setValueFromKey('name')}
        title="Incentive name:"
        value={data.name}
      />
      <Question
        inputProps={{
          InputProps: {
            startAdornment: (
              <InputAdornment position="start">
                <AttachMoneySharpIcon />
              </InputAdornment>
            ),
          },
          id: 'incentive-offer',
          label: 'Incentive Offer',
          type: 'number',
          variant: 'outlined',
        }}
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChange={() => {}}
        readOnly
        title="Incentive offer:"
        value={data.amount}
      />
      <Stack direction="row" flexDirection="row-reverse">
        <LoadingButton
          loading={updateIncentiveMutation.isLoading}
          onClick={onSave}
        >
          Save
        </LoadingButton>
      </Stack>
    </Stack>
  );
};
